import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './layout.css';
import './app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Static prerendered markup (see scripts/postbuild.js) is visible until React
// takes over. On most routes React paints immediately, so we drop the prerender
// straight away and content never appears twice.
//
// Song pages are the exception and they are ~half of all our pageviews. SongView
// has to fetch the song from the Realtime Database before it can render, so
// dropping the prerender on mount deleted fully readable lyrics and replaced them
// with a "Loading..." spinner for well over a second. Instead we leave the
// prerendered page on screen and keep #root hidden until the data lands; SongView
// calls revealApp() to swap them. A safety timeout guarantees the app is revealed
// even if the fetch never resolves, so #root can never stay hidden for good.
const pre = document.getElementById('prerender');
const rootEl = document.getElementById('root') as HTMLElement;
const isSongRoute = window.location.pathname.indexOf('/song/') === 0;
if (pre && pre.parentNode) {
  if (isSongRoute && rootEl) {
    rootEl.style.display = 'none';
    window.setTimeout(() => {
      const stale = document.getElementById('prerender');
      if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
      if (rootEl) rootEl.style.display = '';
    }, 6000);
  } else {
    pre.parentNode.removeChild(pre);
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
